/*
 * Gateway paths for the PUBLIC marketplace surface.
 *
 * Split out for the same reason marketplaceReviewPaths is: a path is the one
 * part of an API binding a test can pin without standing up axios, and the wire
 * contract these mirror is frozen (bluebear-gateway
 * docs/marketplace-seams-2026-09-06.md, "The wire contract", sections 1-4;
 * src/routes/marketplacePublic.routes.ts).
 *
 * None of these authenticate. The gateway's axios baseURL already carries
 * /api/v1, so these are the tail.
 *
 * `manifest` is registered BEFORE `offer` on the gateway so the static segment
 * wins; the order here is cosmetic, but keeping it the same makes the two files
 * readable side by side.
 */
export const marketplaceOfferPaths = {
  configuration: () => '/marketplace/configuration',
  manageConfiguration: () => '/marketplace/configuration/manage',
  /** GET — every offer with status='listed', each with its current version. */
  offers: () => '/marketplace/offers',
  /** GET — the published manifest, byte-for-byte, no envelope. */
  manifest: (slug) => `/marketplace/offers/${encodeURIComponent(slug)}/manifest`,
  /** POST — {contact_email, workspace_id?}. Rate limited to 10/min per IP. */
  requestAccess: (slug) => `/marketplace/offers/${encodeURIComponent(slug)}/request-access`,
  /** POST (authenticated) — buy and start one execution. */
  invoke: (slug) => `/marketplace/offers/${encodeURIComponent(slug)}/invoke`,
  /** GET (authenticated) — buyer-safe status for one paid execution. */
  execution: (executionId) => `/marketplace/executions/${encodeURIComponent(executionId)}`,
  /** GET — one offer. 404 {code:'OFFER_NOT_FOUND'} for anything not listed. */
  offer: (slug) => `/marketplace/offers/${encodeURIComponent(slug)}`,
};

export default marketplaceOfferPaths;
